module.exports = __webpack_public_path__ + "img/kugou.bb462dd0.png";